/**
 * Client-side pagination/filter/sort helper for BizPoint mock list APIs.
 * TODO: Remove when real list endpoints replace mock data.
 *
 * @param {Array} items
 * @param {object} args useSearch callback args
 * @param {{
 *   filterFn?: (items: Array, filters: object) => Array,
 *   keywordFields?: string[],
 *   sortFieldMap?: Record<string, string>,
 * }} [options]
 * @returns {Array} page slice
 */
export const paginateMockItems = (items, args, options = {}) => {
    const {filterFn, keywordFields, sortFieldMap} = options;
    const filters = args.filters ?? {};
    const keyword = (filters.keyword ?? '').toString().trim().toLowerCase();

    let filtered = filterFn ? filterFn(items, filters) : [...items];

    if (keyword) {
        filtered = filtered.filter((item) => {
            if (keywordFields?.length) {
                return keywordFields.some((field) =>
                    String(item?.[field] ?? '').toLowerCase().includes(keyword),
                );
            }
            return JSON.stringify(item).toLowerCase().includes(keyword);
        });
    }

    const orderBy = args.orderBy;
    if (orderBy?.field) {
        const dataField = sortFieldMap?.[orderBy.field] ?? orderBy.field;
        const descending = !!orderBy.descending;
        filtered = [...filtered].sort((a, b) => {
            const av = a?.[dataField];
            const bv = b?.[dataField];
            if (av == null && bv == null) {
                return 0;
            }
            if (av == null) {
                return descending ? 1 : -1;
            }
            if (bv == null) {
                return descending ? -1 : 1;
            }
            if (typeof av === 'number' && typeof bv === 'number') {
                return descending ? bv - av : av - bv;
            }
            const cmp = String(av).localeCompare(String(bv), undefined, {numeric: true, sensitivity: 'base'});
            return descending ? -cmp : cmp;
        });
    }

    const pageSize = args.paginationInfo?.pageSize ?? 10;
    const currentPage = args.paginationInfo?.currentPage ?? 1;
    const start = (currentPage - 1) * pageSize;
    const pageItems = filtered.slice(start, start + pageSize);

    args.setPaginationInfo?.((prev) => ({
        ...prev,
        length: filtered.length,
    }));

    return pageItems;
};
